// extracted by mini-css-extract-plugin
export default {"memberships":"Memberships_memberships__1BKh1","editor":"Memberships_editor__f1jey","detailLink":"Memberships_detailLink__XQnjh"};